import type { MasterAppManifest } from '../../network/httpClients/AzureDevOpsClient/api.schema';

export const QODO_PAT_DOCUMENTATION_LINK =
  'https://docs.qodo.ai/install-and-configure/install/azure-devops#required-pat-permissions';

export const QODO_APP_DOCUMENTATION_LINK =
  'https://docs.qodo.ai/install-and-configure/install/azure-devops#required-oauth-permissions';

export const QODO_TROUBLESHOOTING_LINK =
  'https://docs.qodo.ai/install-and-configure/install/azure-devops#required-oauth-permissions';

export const AZURE_MASTER_APP_MANIFEST: MasterAppManifest = {
  apps: [
    {
      displayName: 'Qodo',
      signInAudience: 'AzureADMultipleOrgs',
      description:
        "Qodo's master app. Grants Qodo permission to create and manage a dedicated app registration in your Azure AD tenant on your behalf.",
      requiredResourceAccess: [
        {
          resourceAppId: '00000003-0000-0000-c000-000000000000',
          resourceAccess: [
            {
              type: 'Role',
              value: 'Application.ReadWrite.All',
              description: 'Create and manage app registrations in your tenant',
            },
            {
              type: 'Role',
              value: 'DelegatedPermissionGrant.ReadWrite.All',
              description: 'Grant admin consent for delegated permissions',
            },
          ],
        },
        {
          resourceAppId: '499b84ac-1321-427f-aa17-267ca6975798',
          resourceAccess: [
            {
              type: 'Scope',
              value: 'user_impersonation',
              description:
                'Access Azure DevOps on behalf of the signed-in user',
            },
          ],
        },
      ],
    },
    {
      displayName: 'Qodo-code-review',
      signInAudience: 'AzureADMyOrg',
      description:
        'Created automatically in your Azure AD tenant after consent. Used for webhook delivery and repository access via Azure DevOps APIs.',
      requiredResourceAccess: [
        {
          resourceAppId: '499b84ac-1321-427f-aa17-267ca6975798',
          resourceAccess: [
            {
              type: 'Scope',
              value: 'user_impersonation',
              description:
                'Access Azure DevOps on behalf of the signed-in user',
            },
          ],
        },
      ],
    },
  ],
};

export const STEP_IDS = {
  CHOOSE_METHOD: 'installation-type',
  REVIEW_MANIFEST: 'review-manifest',
  INSTALL_GUIDE: 'install-guide',
  CONNECT_REPOS: 'connect-repos',
  CHECK_CONNECTION: 'check-connection',
  ENABLE_QODO: 'enable-qodo',
} as const;

export const ENABLE_QODO_TRANSLATION_KEY =
  'dialogs.azure-installation.steps.enable-qodo';

export const CONNECTION_METHODS = {
  APP_REGISTRATION: 'app_registration',
  PAT: 'pat',
  ORG: 'org',
} as const;

export const AZURE_DEV_URL_PREFIX = 'https://dev.azure.com/';
export const HTTPS_PREFIX = 'https://';

export const FORM_IDS = {
  CHOOSE_METHOD: 'installation-type-form',
  INSTALL_GUIDE: 'install-guide-form',
  CONNECT_REPOS: 'connect-repos-form',
  CONNECT_PAT: 'pat-connect-form',
} as const;

export const CONSENT_STATE_TTL_MS = 30 * 60 * 1000; // 30 minutes

export const AZURE_QODO_LOGO_PATH = '/images/azure-installation/qodo-logo.png';

export const SELECTION_ACTIONS = {
  TOGGLE_REPO: 'TOGGLE_REPO',
  TOGGLE_PROJECT_REPOS: 'TOGGLE_PROJECT_REPOS',
  TOGGLE_ORG_REPOS: 'TOGGLE_ORG_REPOS',
  SET_EXPANDED_ORGS: 'SET_EXPANDED_ORGS',
  SELECT_ALL_REPOS: 'SELECT_ALL_REPOS',
} as const;

export const CONNECT_REPOS_STEP_INDEX = 3;
export const OAUTH_PARAMS = [
  'error',
  'error_description',
  'code',
  'state',
  'success',
  'tenant',
];
